import { render, staticRenderFns } from "./MenuTogglerIcon.vue?vue&type=template&id=5faae932"
import script from "./MenuTogglerIcon.vue?vue&type=script&lang=js"
export * from "./MenuTogglerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports